import { render, staticRenderFns } from "./PillFilterControl.vue?vue&type=template&id=990bb1ee&scoped=true&"
import script from "./PillFilterControl.vue?vue&type=script&lang=js&"
export * from "./PillFilterControl.vue?vue&type=script&lang=js&"
import style0 from "./PillFilterControl.vue?vue&type=style&index=0&id=990bb1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990bb1ee",
  null
  
)

export default component.exports